import { Box, Paper, useTheme } from '@mui/material';
import LoginRightContent from './LoginRightContent';
import { useState } from 'react';
import SetTheme from '../common/SetTheme';

function LoginRight(props) {
	const isConsentRenewal = global.renewConsentId;
	const theme1 = useTheme();
	// eslint-disable-next-line no-unused-vars
	const [theme, setTheme] = useState(props?.theme ? props.theme : theme1);

	// Check for dark theme
	const isDark =
		props.customDetails?.darkTheme === true || theme1.palette.mode === 'dark';

	return (
		<Box
			sx={{
				display: { xs: 'none', sm: 'none', md: 'flex' },
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 2,
				backgroundColor: isDark
					? '#161616'
					: props?.customDetails?.loginRightBackground ??
					  props.customDetails.primaryColor,
				height: '100%',
				minHeight: 0,
				overflow: 'hidden',
				padding: {
					md: '1.5rem 5.5rem',
					lg: '2rem 7.5rem',
				},
				borderLeft: props?.customDetails?.loginRightBorderColor
					? `1px solid ${
							isDark ? '#7A8185' : props?.customDetails?.loginRightBorderColor
					  }`
					: '0',
				color: isDark ? '#fff' : '#000',
				background: props?.customDetails?.loginCoverImage
					? 'transparent'
					: props.customDetails.primaryColor,
			}}
		>
			<SetTheme customDetails={props.customDetails} setTheme={setTheme} />
			<Paper
				sx={{
					padding: isConsentRenewal ? '1.5rem' : '2rem',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					margin: 0,
					maxHeight: '100%',
					overflow: 'hidden',
					border: props?.customDetails?.loginRightContentBorderColor
						? `1px solid ${
								isDark
									? '#7A8185'
									: props?.customDetails?.loginRightContentBorderColor
						  }`
						: '0',
					backgroundColor: isDark ? '#161616' : '#fff',
					color: isDark ? '#fff' : '#000',
					...(isConsentRenewal && {
						borderRadius: '8px',
					}),
				}}
			>
				<LoginRightContent {...props} />
			</Paper>
		</Box>
	);
}

export default LoginRight;
